import { render, staticRenderFns } from "./ClientManagment.vue?vue&type=template&id=875cca0c&scoped=true&"
import script from "./ClientManagment.vue?vue&type=script&lang=js&"
export * from "./ClientManagment.vue?vue&type=script&lang=js&"
import style0 from "./ClientManagment.vue?vue&type=style&index=0&id=875cca0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875cca0c",
  null
  
)

export default component.exports